import { useRef, useState } from 'react';
import { t } from 'i18next';

import styles from './styles.module.scss';

import Notification from '../../../models/Notifications/Notification';
import { getPreferredLanguage } from 'utils/preferredLanguage';
import Icon from 'components/icon';
import useOnClickOutside from 'models/utils/useOnClickOutside';
import { useNotifications } from 'context/NotificationContext';
import { checkAsRead } from 'services/notifications';

function Card(props : Notification) : JSX.Element {
  const [showOptions, setShowOptions] = useState(false);
  const { setAsRead } = useNotifications();

  const ref = useRef(null);
  useOnClickOutside(ref, () => setShowOptions(false));

  const onClick = () : void => {
    checkAsRead(props.id)
      .then(() => setAsRead(props.id));
  };

  const formatDate = () : string => {
    if(!props.date)
      return '';

    const date = new Date(props.date);
    return date.toLocaleDateString(getPreferredLanguage(), {
      day: 'numeric',
      month: 'long',
      hour: '2-digit',
      minute: '2-digit'
    },);
  };

  return (
    <>
      <div
        ref={ref}
        className={styles['biobar-notification-card']}>
        <div className={styles['biobar-notification-card-content']}>
          <a href={props.link} onClick={onClick} target='_blank' rel="noreferrer">
            <div>
              <div className={styles['biobar-notification-icon']}>
                <Icon iconName="notifications" useOutlined={true}>
                  {props.read ? <></> : <div className={styles['biobar-notifications-unread']}></div>}
                </Icon>
              </div>
            </div>
            <div className={styles['biobar-notification-message']}>
              <p className={styles['biobar-notification-title']}>
                {props.title}
              </p>
              <div className={styles['biobar-notification-description']}>
                <p>{props.message}</p>
              </div>
              <div className={styles['biobar-notification-footer']}>
                <p>{formatDate()}</p>
              </div>
            </div>
          </a>
          <div className={styles['biobar-notification-more']} onClick={() : void => setShowOptions((x : boolean) => !x) }>
            <Icon
              iconName="more_horiz"
              className={styles[`biobar-notification-more-button${showOptions ? '-active' : ''}`]}
            />
            {
              showOptions &&
              <div className={styles['biobar-notification-more-dropdown']}>
                <div
                  id="biobar-notification-more-dropdown-div"
                  onClick={onClick}
                  className={styles['biobar-notification-more-dropdown-content']}>
                  <a id="biobar-notification-more-dropdown-link">{t('biobar.notification.card.action')}</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;